import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IUnregisterPushTokenBody } from './unregister-push-token-request';
import type { IUnregisterPushTokenResponse } from './unregister-push-token-response';
import { unregisterPushTokenResponseSchema } from './unregister-push-token-response';

export async function unregisterPushTokenApi(
  body: IUnregisterPushTokenBody,
): Promise<IValidatedResponse<IUnregisterPushTokenResponse>> {
  return postRequest<IUnregisterPushTokenResponse>({
    path: '/account/push-token/unregister',
    body,
    schema: unregisterPushTokenResponseSchema,
  });
}
